import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {
  ToggleButton as MuiToggleButton,
} from '@mui/material';

const StyledToggleButton = styled(MuiToggleButton)`
  color: ${({ theme }) => theme.palette.text.primary};
  background-color: ${({ theme }) => theme.palette.common.white};
  &.Mui-disabled {
    color: ${({ theme }) => theme.palette.grey[5]};
  }
  &.Mui-selected, &.Mui-selected:hover {
    color: ${({ theme }) => theme.palette.common.white};
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
  &:hover {
    background-color: transparent;
  }
  border: 1px solid ${({ theme }) => theme.palette.grey[5]} !important;
  text-transform: unset !important;
  font: ${({ theme }) => theme.typography.button};
  &:focus {
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.common.white};
  }
`;

export const ToggleButton = ({ children, ...rest }) => (
  <StyledToggleButton
    disableRipple
    {...rest}
  >
    {children}
  </StyledToggleButton>
);

ToggleButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
